import { render, staticRenderFns } from "./comp12.vue?vue&type=template&id=c387a1ea&scoped=true"
import script from "./comp12.vue?vue&type=script&lang=ts"
export * from "./comp12.vue?vue&type=script&lang=ts"
import style0 from "./comp12.vue?vue&type=style&index=0&id=c387a1ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c387a1ea",
  null
  
)

export default component.exports